let placeSearch;
let autocomplete;
const componentForm = {
	street_number: "short_name",
	route: "long_name",
	locality: "long_name",
	administrative_area_level_1: "short_name",
	country: "long_name",
	postal_code: "short_name",
};

function initAutocomplete() {
	// Create the autocomplete object, restricting the search predictions to
	// geographical location types.        var defaultBounds = new google.maps.LatLngBounds(

	var options = {
		types: ["geocode"],
		componentRestrictions: { country: ["ca", "us"] },
		fields: ["address_components", "geometry", "icon", "name"]
	};

	autocomplete = new google.maps.places.Autocomplete(
		document.getElementById("autocomplete"),
		options
	);
	// Avoid paying for data that you don't need by restricting the set of
	// place fields that are returned to just the address components.

	autocomplete.setFields(["address_component"]);
	// When the user selects an address from the drop-down, populate the
	// address fields in the form.
	autocomplete.addListener("place_changed", fillInAddress);
}

function fillInAddress() {
	// Get the place details from the autocomplete object.
	const place = autocomplete.getPlace();
	// console.log(place);
	for (const component in componentForm) {
		document.getElementById(component).value = "";
		document.getElementById(component).disabled = false;
	}

	// console.log(place.address_components);

	// Get each component of the address from the place details,
	// and then fill-in the corresponding field on the form.
	// for (const component of place.address_components) {
	// 	const addressType = component.types[0];
	// 	// console.log(component);

	// 	if (componentForm[addressType]) {
	// 		let val = component[componentForm[addressType]];
	// 		document.getElementById(addressType).value = val;
	// 	}
	// }

	let val;
	for (const component of place.address_components) {
		let addressType = component.types[0];
		if (addressType === 'postal_code') {
			val = component[componentForm['postal_code']];
		}
	}

	document.getElementById('autocomplete').value += `${val ? ' '+ val : ''}`;
}
